<template>
    <div class="page course-column">

        <column-skeleton v-if="loading" style="margin-bottom: 100vh"></column-skeleton>

        <img :src="course.cover_img" class="course-column-banner">

        <div class="course-column-header">
            <div class="header-title">
                <img class="header-title-column" src="/static/img/course/icon_tag_column.svg" alt="">
                {{course.title}}
            </div>
            <div class="header-author">{{course.course_desc}}</div>
            <div class="header-view">
                <div class="header-time-long">已开课{{course.current_count}}节 | 共{{course.total_count}}节</div>
                <div class="header-view-count">
                    <div class="header-view-count-text">{{course.view_count}}人学习</div>
                    <div class="header-view-count-images">
                        <img :src="item" alt="" v-for="(item,index) in course.last_study_user_avatar" :key="index">
                    </div>
                </div>
                <div class="clear"></div>
            </div>
        </div>

        <div class="course-column-content">
            <van-tabs title-class="course-column-content-tab" :swipeable="true" :sticky="true" animated :border="true" :background="'#Fff'">
                <van-tab :title="'目录'">
                    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
                        <van-cell v-for="(item,index) in list" :key="item.id" @click="go_detail(item)" :border="false">
                            <div class="course-column-content-left">{{index+1 < 10 ? '0'+(index+1) : index+1}}</div>
                            <div class="course-column-content-right">
                                <div class="course-column-content-right-title">{{item.title}}</div>
                                <div class="course-column-content-right-detail">
                                    {{item.duration_format == "" ? "" : item.duration_format+"/"}}{{item.view_count}}人学习 {{item.progress}}
                                    <img class="float-right" src="/static/img/course/icon_course_list_play.svg" alt="">
                                </div>
                            </div>
                        </van-cell>
                    </van-list>
                </van-tab>
                <van-tab :title="'介绍'" v-if="course.content !== '<p><br></p>'" class="course-column-intro" style="padding: 15px">
                    <div v-html="course.content"></div>
                </van-tab>
                <van-tab v-else :title="''" disabled />
            </van-tabs>
        </div>
    </div>
</template>

<script>
    import Interface from "@/util/interface"
    import columnSkeleton from "@/skeleton/columnSkeleton"

    export default {
        name: 'course-column',
        components :{
            'column-skeleton' : columnSkeleton
        },
        data() {
            return {
                value: "",
                active: "",
                list: [],
                loading: true,
                finished:true,
                course:{},
                share_data :{},
                showShareDialog:false,
                htmlUrl:"",
                isShow:false,
                status:""
            }
        },
        methods : {
            onLoad(){},
            fetch(scene){
                if (scene === 'course') {
                    Interface.getData('get', Interface.short_video.detail+'/'+this.id).then((res) => {
                        this.course = res.data
                        this.list  = res.data.items
                        setTimeout(()=>{this.loading = false;},500)
                        if(this.course){
                            Interface.getShareInfo(this,this.course.title,this.course.cover_img,this.course.course_desc)
                        }
                    })
                }else if (scene === 'share') {
                    let params = {
                        content_id : this.id,
                        type:3,
                    }
                    Interface.getData('get', Interface.share,params).then((res) => {
                        this.htmlUrl = res.data.post_img_url
                    })
                }
            },
            favorite(){
                Interface.getData('get', Interface.short_video.favorite+this.id).then((res) => {
                    if(res.code == 0){
                        this.course.isFavorite = !this.course.isFavorite
                    }
                })
            },
            go_detail(item){
                this.$router.push({name:'video-detail',params: { id: item.id }})
            },
            openShareData(){
                this.showShareDialog = true
            },
            setCurrentUrl: () => {
                let url = location.href.replace(/&wx=[-]{}/g, '');
                window.history.replaceState({}, document.title, url);
            }
        },
        created(){
            this.setCurrentUrl()
            this.id = this.$route.params.id
            this.fetch('course')
            this.fetch('share')
        },
    }
</script>

<style lang="scss">
    @import "./index.scss";
</style>



// WEBPACK FOOTER //
// src/views/video/column/index.vue